<div
  class="osm-map"
  [class.osm-map--compact]="compact"
  data-testid="osm-map"
>
  <div
    #mapEl
    class="osm-map__canvas"
    role="application"
    [attr.aria-label]="ariaLabel"
  ></div>
  <button
    type="button"
    class="osm-map__locate"
    data-testid="osm-locate"
    [class.osm-map__locate--busy]="userGeo.status() === 'prompting'"
    [class.osm-map__locate--active]="userGeo.status() === 'granted'"
    [attr.aria-pressed]="userGeo.status() === 'granted'"
    aria-label="La mia posizione"
    title="La mia posizione"
    (click)="onLocate()"
  >
    <i class="bi bi-geo-alt-fill" aria-hidden="true"></i>
  </button>
  @if (locateHint()) {
    <p class="osm-map__hint mb-0" data-testid="osm-locate-hint">{{ locateHint() }}</p>
  }
  @if (markers.length === 0 && emptyMessage) {
    <p class="osm-map__empty mb-0">{{ emptyMessage }}</p>
  }
</div>
